/*
 * @Desc: 城市
 * @Author: lc
 * @Date: 2023-09-26 09:28:06
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-27 11:15:48
 */
import request from "@/utils/request";
const city = {
  // 列表
  list (query) {
    return request({
      url: "/community/list",
      method: "get",
      params: query
    });
  },
  // 下拉选
  select (query) {
    return request({
      url: "/community/select",
      method: "get",
      params: query
    });
  },
  // 编辑
  edit (data) {
    return request({
      url: "/community/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail (data) {
    return request({
      url: "/community/detail",
      method: "post",
      data
    });
  },
  // 同步
  sync (data) {
    return request({
      url: "/community/sync",
      method: "post",
      data
    });
  },
  syncHik (data) {
    return request({
      url: "/community/syncHik",
      method: "post",
      data
    });
  },
  // 小区内资源 列表
  resourceList (query) {
    return request({
      url: "/resource/list",
      method: "get",
      params: query
    });
  },
  listTwo(query) {
    return request({
      url: "/resource/listTwo",
      method: "get",
      params: query
    });
  },
  listThree(query) {
    return request({
      url: "/resource/listThree",
      method: "get",
      params: query
    });
  },
  findUser(data) {
    return request({
      url: "/resource/findUser",
      method: "post",
      data
    });
  },
  // 小区内资源 详情
  resourceDetail (data) {
    return request({
      url: "/resource/detail",
      method: "post",
      data
    });
  },
  // 同步资源
  resourceSync (data) {
    return request({
      url: "/resource/sync",
      method: "post",
      data
    });
  },
  bindList (query) {
    return request({
      url: "/resource/bindList",
      method: "get",
      params: query
    });
  },
  exportData(query) {
    return request({
      url: "/resource/exportData",
      method: "post",
      params: query
    });
  },
  huoyueList(query) {
    return request({
      url: "/resource/huoyueList",
      method: "post",
      params: query
    });
  },
  exportHuoyueList(query) {
    return request({
      url: "/resource/exportHuoyueList",
      method: "post",
      params: query
    });
  },
  bindCount (query) {
    return request({
      url: "/resource/bindCount",
      method: "get",
      params: query
    });
  },
  priv (query) {
    return request({
      url: "/community/priv",
      method: "get",
      params: query
    });
  },
  editpriv(query) {
    return request({
      url: "/community/editpriv",
      method: "post",
      params: query
    });
  },
  edittishi (query) {
    return request({
      url: "/dylcomtishi/edit",
      method: "post",
      params: query
    });
  },
  importexcel (query) {
    return request({
      url: "/resource/importexcel",
      method: "post",
      params: query
    });
  },
};
export default city;
